<script type="ts">
    import { useNavigate } from 'svelte-navigator';
    import authStore from '../../store/auth';
    import ButtonRounded from '../../common/ButtonRounded.svelte';
    import OtpInput from 'svelte-otp';
    import { parseMobile } from '../../services/utils'
    import { getOtp as GetOTP, verifyOtp as VerifyOtp } from '../../domain/auth/login.action'
    import { onMount } from 'svelte';
    import Header from '../../components/Header.svelte';
    import Footer from '../../components/Footer.svelte';
    import toast from '../../services/toast';

    const navigate = useNavigate();
    
    let otpInstance: {getValue: () => { completevalue: string; isInputComplete: boolean; }};
    let loading = false
    let errors: Record<string, string> = {}
    let waitingTime = 120;

    const isValidEmail = email => {
        const emailRegex = new RegExp(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, "gm");
        return emailRegex.test(email);
    }

    const isValidPhone = phone => {
        const phoneRegex = new RegExp(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/, "gm");
        return phoneRegex.test(phone);
    }

    const isValidOTP = otp => {
        // const otpRegex = new RegExp(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/, "gm");
        // return otpRegex.test(otp);
        return true
    }

    const resend = async () => {
        const phone = $authStore.user.mobile

        errors = {};
        const mobile = parseMobile(phone)
        if (!mobile || (mobile && !isValidPhone(mobile))) {
            errors.phone = "Phone is required";
            toast.warn(errors.phone);
            return
        }
        loading = true
        try {
            const response = await GetOTP(mobile)
            authStore.setMobile(mobile);
            toast.success(`An otp has been sent to your email and phone number ${mobile}`)
            startTimer()
        } catch (e) {
            errors.review = e.toString()
            toast.error({message: errors.review});
        } finally {
            loading = false
        }
        
    }

    const submitOtp = async () => {
        errors = {};
        const mobile = parseMobile($authStore.user.mobile)
        const otp: string = (otpInstance?.getValue().completevalue || '').trim();;
        
        if (!otp || (otp && !isValidOTP(otp))) {
            errors.otp = "OTP is required";
            toast.warn(errors.otp);
            return
        }
        loading = true
        try {
            const response = await VerifyOtp(mobile, otp)
            const { token } = response
            authStore.login(token);
            navigate('/choose-business');
        } catch (e) {
            const { message = "An error occured"} = e;
            errors.review = message
            toast.error({message});
        } finally {
            loading = false
        }
    
        // authStore.setUser(data);
    }

    let startTimer = () => {
        const timeout = setInterval(() => {
            waitingTime--;
            if (waitingTime <= 0) {
                clearInterval(timeout);
            }
        }, 1000);
    };

    $: {
        if (
            $authStore.isLoggedIn
        ) {
            navigate("/choose-business")
        }
    }

    onMount(() => {
        startTimer();
        toast.success(`An otp has been sent to your email and phone number ${$authStore.user.mobile}`)
    });

    
</script>

<Header/>
<div class="flex h-full justify-center items-center">
    <div class="w-full">
        <div class="display-flex">
            <div class="flex flex-col">
                
                <div class="relative mx-8 mt-16 mb-8 text-gray-400">
                    <strong class="text-black text-md secondary-text-color">
                        We’ve sent you a text message!
                    </strong>
                    <br/>
                    <span class="text-xs primary-text-color">
                        Enter the 6-digit code sent to { $authStore.user.mobile } to validate your access. We also sent this code to your registered email address.
                    </span>

                    <div class="mt-4">
                        <div class="">
                            <div class="flex">
                                <OtpInput 
                                    numberOfInputs={6} placeholder="------" 
                                    separator="" 
                                    customWrapperClass="flex" 
                                    customRowClass="border-0 border-b border-black mr-2 px-2 py-1 text-sm text-center"
                                    customInputWrapperClass="border-0"
                                    customTextInputClass="border-0 text-center"
                                    bind:this={otpInstance}
                                />
                            </div>
                            
                            <div class="mb-4 text-xs text-center mt-4 primary-text-color">
                                {#if waitingTime > 0}
                                You can resend in <span>{ `0${Math.floor(waitingTime / 60)}:${waitingTime % 60}` }</span>
                                {:else}
                                <!-- svelte-ignore a11y-click-events-have-key-events -->
                                <span class="secondary-text-color cursor-pointer" on:click={resend}>Resend</span> otp
                                {/if}
                            </div>
                            <ButtonRounded
                                loading={loading}
                                on:click={submitOtp}
                                title=""
                                className="call-btn-bg-color h-10 mt-4 w-full flex-inline text-white px-8 text-sm"
                            >
                            Complete sign in
                            </ButtonRounded>
                        </div>
                        {#if errors.review}
                            <small class="text-xs text-red-500">{ errors.review }</small>
                        {/if}
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
<Footer/>

<style>
    .primary-text-color {
        color: var(--primary-text-color)
    }
    .secondary-text-color {
        color: var(--secondary-text-color)
    }
</style>
